import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../../../styles/vendeurs/VendeurHeader.css';
import { fetchNotifications, marquerNotificationsCommeLues } from '../../../services/notificationService';
import { asset } from '../../../services/api';

function VendeurHeader() {
  const [vendeur, setVendeur] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const data = localStorage.getItem('vendeurConnecte');
    if (data) {
      try {
        const vendeurObj = JSON.parse(data);
        setVendeur(vendeurObj);

        fetchNotifications(vendeurObj.id).then((notif) => {
          const nonLues = notif.filter(n => !n.lu);
          setNotifications(nonLues);
        });
      } catch (e) {
        console.error('Erreur parsing vendeurConnecte', e);
      }
    } else {
      navigate('/vendeur/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('vendeurConnecte');
    alert('Déconnexion réussie');
    setMenuOpen(false);
    navigate('/vendeur/login');
  };

  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenu(false);
    setMenuOpen(false);
  };

  return (
    <header className="vendeur-header">
      <div className="vendeur-header-left">
        <Link to="/vendeur/produits" className="logo logo-link">
          <img src="/images/logotantsaha.png" alt="Logo" className="logo-image" />
          <h2 className="vendeur-title">🛍️ Espace Vendeur</h2>
        </Link>
        <button className="menu-toggle" onClick={() => setMobileMenu(!mobileMenu)}>☰</button>
      </div>

      {vendeur && (
        <>
          {/* Notification TOUJOURS visible */}
          <button
            onClick={() => {
              marquerNotificationsCommeLues(vendeur.id)
                .then(() => fetchNotifications(vendeur.id))
                .then((notif) => {
                  const nonLues = notif.filter(n => !n.lu);
                  setNotifications(nonLues);
                  handleNavigation('/vendeur/notifications');
                })
                .catch((err) => console.error("Erreur marquage/chargement notifications", err));
            }}
            className="notification-button always-visible-notif"
          >
            🔔 {notifications.length}
          </button>

          <nav className={`vendeur-actions-horizontal ${mobileMenu ? 'open' : ''}`}>
            <button onClick={() => handleNavigation('/vendeur/produits')} className="header-link">🛒 Produits</button>
            <button onClick={() => handleNavigation('/vendeur/produits/ajouter')} className="header-link">➕ Ajouter</button>
            <button onClick={() => handleNavigation('/vendeur/commandes')} className="header-link">📦 Commandes</button>

            <div className="profile-menu-wrapper">
              <span className="vendeur-nom-header">{vendeur.prenom} {vendeur.nom}</span>
              <img
                src={vendeur?.photo_profil ? asset(vendeur.photo_profil) : "https://i.pravatar.cc/45"}
                alt="Profil"
                className="vendeur-avatar"
                onClick={() => setMenuOpen(!menuOpen)}
                onError={(e) => {
                  if (!e.currentTarget.dataset.fallback) {
                    e.currentTarget.src = "https://i.pravatar.cc/45";
                    e.currentTarget.dataset.fallback = "true";
                  }
                }}
              />

              {menuOpen && (
                <ul className="vendeur-menu">
                  <li onClick={() => handleNavigation('/vendeur/profile')}>👤 Mon profil</li>
                  <li onClick={handleLogout}>🚪 Déconnexion</li>
                </ul>
              )}
            </div>
          </nav>
        </>
      )}
    </header>
  );
}

export default VendeurHeader;
